import React, { Component } from 'react'

import { forIn } from 'lodash'
import { doSort } from 'utils'

class FolderSelectorContents extends Component {
	constructor(props){
		super(props)

		const {
			isFileFolder,
			folder,
			allFolders,
			depth
		} = this.props

		this.childFolders = []

		if(isFileFolder){
			// actually a project
			forIn(allFolders, folderObject => {
				if(folder.folder_id){
					if(!folderObject.file_folder_id){
						this.childFolders.push(folderObject)
					}
				}else{
					if(folderObject.file_folder_id == folder.id){
						this.childFolders.push(folderObject)
					}
				}
			})
		}else{
			forIn(folder.folders, folderId => {
				this.childFolders.push(allFolders[folderId])
			})
		}

		this.childFolders = doSort(this.childFolders, 'alpha', 'name')

		this.depth = depth + 1
	}

	render(){
		const {
			folder,
			currentParentId,
			parentFolderChange,
			isFolder,
			folderId,
			allFolders,
			isFileFolder
		} = this.props

		let dashes = []

		for (var i = this.depth - 2; i > 0; i--) {
			dashes.push(i)
		}

		let isSelected = null

		if(currentParentId == folder.id){
			isSelected = true
		}else if(isFileFolder && !currentParentId && folder.folder_id){
			isSelected = true
		}

		return (
			<li>
				<label 
					onClick={_ => {parentFolderChange(folder.id)}} 
					className={isSelected ? 'selected' : null}
				>
					{
						dashes.map((i) => {
							return (
								<em key={i}>
									&mdash;
								</em>
							)
						})
					}
					<span>
						{ ((isFileFolder && folder.folder_id) || (!isFileFolder && folder.is_root)) ? '(None)' : folder.name }
					</span>
				</label>
				<ul>
					{
						this.childFolders.map(folder => {
							let showFolder = true

							if(isFolder && folderId == folder.id){
								showFolder = false
							}

							if(showFolder){
								return(
									<FolderSelectorContents 
										isFolder={isFolder} 
										isFileFolder={isFileFolder}
										folderId={folderId} 
										parentFolderChange={parentFolderChange} 
										currentParentId={currentParentId} 
										depth={this.depth} 
										key={folder.id} 
										allFolders={allFolders} 
										folder={folder} 
									/>
								)
							}
						})
					}
				</ul>
			</li>
		);
	}

}

export default FolderSelectorContents;  


// WEBPACK FOOTER //
// ./src/components/modal/modal-components/folder-selector-contents.jsx